import React from 'react'
import LotCategoryGrid from '../components/grids/LotCategoryGrid'

const LotCategorySettingsPage = () => {
    return (
        <div id='settings-lot-categories-page' className='stretched row-based container'>
            <LotCategoryGrid />
        </div>
    )
}

export default LotCategorySettingsPage